import script from "./WaterfallRace.vue?vue&type=script&setup=true&lang=js"
export * from "./WaterfallRace.vue?vue&type=script&setup=true&lang=js"

import "./WaterfallRace.vue?vue&type=style&index=0&id=15599da6&setup=true&lang=css"

const __exports__ = script;

export default __exports__